import BrittanyMcGee from "../../assets/speaker-imgs/BrittanyMcGee.jpg"; 
import HodaSolati from "../../assets/speaker-imgs/HodaSolati.png"; 
import JCPrice from "../../assets/speaker-imgs/JCPrice.jpeg";
import JennaRitten from "../../assets/speaker-imgs/JennaRitten.jpg";
import JessicaHoopfer from "../../assets/speaker-imgs/JessicaHoopfer.jpg";
import KanikaMohan from "../../assets/speaker-imgs/KanikaMohan.jpeg";
import KavithaBangalore from "../../assets/speaker-imgs/KavithaBangalore.jpg";
import LorrenaBlack from "../../assets/speaker-imgs/LorrenaBlack.jpg";
import ShantaleaJohns from "../../assets/speaker-imgs/ShantaleaJohns.jpg";
import MattalynnDarden from "../../assets/speaker-imgs/MattalynnDarden.jpeg";
import ShimaSolati from "../../assets/speaker-imgs/ShimaSolati.jpg";
import ShrutiAgarwal from "../../assets/speaker-imgs/ShrutiAgarwal.png";




import Bell from "../../assets/flowers/Bell.png";
import BellBlue from "../../assets/flowers/bellBlue.png";
import Bluebell from "../../assets/flowers/Bluebell.png"; 
import Hydrangea from "../../assets/Hydrangea.png";
import blueHydrangea from "../../assets/flowers/blueHydra.png";
import Dandelion from "../../assets/flowers/Dandelion.png";
import osteoPink from "../../assets/flowers/osteoPink.png";
import osteoPurple from "../../assets/flowers/osteoPurple.png";
import osteoOrange from "../../assets/flowers/osteoOrange.png";
import rose from "../../assets/flowers/Soft red flower.png";
import sunflower from "../../assets/flowers/sunflower.png";
import purpleHydra from "../../assets/flowers/purpleHydra.png";


const speakersData = [
  {
    imageurl: BrittanyMcGee,
    name: "Brittany McGee",
    position: "Founder and CEO",
    company: "OptimizeEV",
    flower: Bell,
  },
  {
    imageurl: HodaSolati,
    name: "Hoda Solati",
    position: "UX/UI Researcher & Designer",
    company: "BraunAbility",
    flower: Hydrangea,
  },
  {
    imageurl: JCPrice,
    name: "JC Price",
    position: "Founder",
    company: "Scope Focus",
    flower: purpleHydra,
  },
  {
    imageurl:JennaRitten,
    name: "Jenna Ritten",
    position: "Chief Developer Advocate & Architect",
    company: "IBM",
    flower: BellBlue,
  },
  {
    imageurl: JessicaHoopfer,
    name: "Jessica Hoopfer",
    position: "Manager, North America - Enterprise Sales",
    company: "Checkout.com",
    flower: Dandelion,
  },
  {
    imageurl: KanikaMohan,
    name: "Kanika Mohan",
    position: "Product Manager",
    company: "IBM",
    flower: blueHydrangea,
  },

  {
    imageurl: KavithaBangalore,
    name: "Kavitha Bangalore",
    position: "Cybersecurity Analyst",
    company: "Cleveland Clinic ",
    flower: osteoPink,
  },
  {
    imageurl: LorrenaBlack,
    name: "Lorrena Black",
    position: "Founder & CEO",
    company: "She Served LLC",
    flower: rose,
  },
  {
    imageurl: MattalynnDarden,
    name: "Mattalynn Darden",
    position: "SOC Analyst",
    company: "Comerica Bank",
    flower: osteoPurple,
  },
  {
    imageurl: ShantaleaJohns,
    name: "Shantalea Johns",
    position: "Founder & CEO",
    company: "Wayne State University",
    flower: sunflower,
  },
  {
    imageurl: ShimaSolati,
    name: "Shima Solati",
    position: "UX/UI Researcher & Designer",
    company: "BraunAbility",
    flower: osteoOrange,
  },
  {
    imageurl: ShrutiAgarwal,
    name: "Shruti Agarwal",
    position: "Business Analyst",
    company: "Levelwing Media LLC",
    flower: Bluebell,
  },
];

export default speakersData;
